import { useEffect, useState } from "react";

import { showMessage } from '../../config.js';

export default function PrequelQues({ partner, checklistObj, setChecklistObj, handleCreateChecklist }) {

    let [focusAreaCount, setFocusAreaCount] = useState({ focus1: 0, focus2: 0, focus3: 0 });

    const handleAreaFocus = async (e, item) => {
        if (e.target.value.length <= 200) {
            setChecklistObj({ ...checklistObj, [item]: e.target.value });
            focusAreaCount = { ...focusAreaCount, [e.target.name]: e.target.value.length };
            setFocusAreaCount(focusAreaCount);
        }
    };

    return (
        <>
            <div className='df fdc w80'>
                <h3 className='w100 c15 fs1rem fw400 lh2 mb1rem'>Areas of your specific focus <span className='fs1rem c15 fsi' style={{ color: '#15131330' }}>(optional)</span></h3>
                {Object.values(partner['focusArea']).map((item, idx) => {
                    return <div className='pr mb-05rem'>
                        <label className='c15 fs0-75rem my0-5rem db w100'>0{idx + 1} - {item}</label>
                        <textarea value={checklistObj?.[item] || ''} onChange={(e) => handleAreaFocus(e, item)} onBlur={(e) => handleAreaFocus(e, item)} onInput={(e) => handleAreaFocus(e, item)}  rows='3' style={{ resize: 'none', background: '#F4FFE1' }} name={`focus${idx + 1}`} className='bss bw2px bo5 w100 br10px p1rem mb1rem fs0-75rem'
                            placeholder='Write your objective focus in your own words (up to 200 characters max)'></textarea>
                        <span className={`pa b0 r0 mb2rem mr1rem fs0-75rem ${focusAreaCount[`focus${idx + 1}`] >= 199 ? 'c4' : 'c16'}`}>{focusAreaCount[`focus${idx + 1}`]}/200</span>
                    </div>
                })}
            </div>
            <div className='w100 pr b0 df jcsb px2rem pr4rem mt2rem'>
                <p className='c15 fs1rem'>Don’t worry! The rest of our checklist is multiple choice.</p>
                <button onClick={() => handleCreateChecklist()} className={`shadow c1 fw400 fs1rem pr br38px w200px h3rem df aic jcc bg4 bg3-hover cp`}>
                    Ok, next
                    <i className='icon pr ml0-5rem' style={{ top: '3px' }}>
                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.42954 17.0154H21.1966L16.7035 22.1842C15.413 23.6688 17.3488 25.8957 18.6394 24.4111L22.7314 19.6964L25.463 16.5491C25.9924 15.9365 25.9924 14.9471 25.463 14.3344L18.6394 6.47557C18.3798 6.16869 18.0225 5.99649 17.6502 6.00005C16.4212 6.00023 15.818 7.72225 16.7035 8.70263L21.2073 13.8714H6.35888C4.46611 13.9794 4.60744 17.1238 6.42954 17.0154Z" fill="white" />
                        </svg>
                    </i>
                </button>
            </div>
        </>
    )
}